export const emailInput = {
  error: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  emailAlreadyRegisteredError:
    'Für diese E-Mail-Adresse besteht bereits ein Konto bei myHausHeld oder eine Anfrage bei HausHeld. Bitte setzen sie ihr {link}.',
  forgotPasswordLinkText: 'Passwort zurück',
}
